<template>
  <!-- Обёртка для анимации -->
  <Transition
      name="drawer-slide"
      @before-enter="onOpened"
      @before-leave="onClosed"
  >
    <!-- Drawer правый -->
    <div
        v-if="open"
        class="fixed inset-y-0 right-0 z-[10000] w-[375px] bg-layer-0 shadow-xl flex flex-col"
    >
      <!-- Header -->
      <div class="flex items-center justify-between px-4 py-3 border-b border-white/10">
        <h3 class="text-md font-semibold text-white">{{ title }}</h3>
        <button @click="selfClose" class="text-white opacity-75 hover:opacity-100">
          <XMarkIcon class="size-5" />
        </button>
      </div>

      <!-- Content -->
      <div class="flex-1 overflow-y-auto px-6 py-4">
        <slot />
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { defineProps, defineEmits, onBeforeUnmount } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import emitter from "@/services/emitter.service"

defineProps({
  open: Boolean,
  title: String
})

const emit = defineEmits(['closed'])
const selfClose = () => emit("closed")

const onOpened = () => emitter.emit("drawer_shift_state", { open: true })
const onClosed = () => emitter.emit("drawer_shift_state", { open: false })

onBeforeUnmount(onClosed)
</script>

<style>
.drawer-slide-enter-active,
.drawer-slide-leave-active {
  transition: transform 0.2s ease;
}

.drawer-slide-enter-from,
.drawer-slide-leave-to {
  transform: translateX(100%);
}

.drawer-slide-enter-to,
.drawer-slide-leave-from {
  transform: translateX(0%);
}
</style>
